export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12031.e662e42c.jpg";